/*
 *  Links List - Create a list of links, and then share it!
 *  Copyright (c) Luke Denton
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation; either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import Authentication from "@components/Authentication";
import EditButtonInline from "@components/EditButtonInline";
import UserAccount from "@components/UserAccount";
import Analytics from "@utils/Analytics";
import DataStore from "@utils/DataStore";

export default {
  name: "Header",

  components: {
    EditButtonInline,
    Authentication,
    UserAccount
  },

  data() {
    return {
      showTitleEditButton: false,
      showDescriptionEditButton: false,
      isEditingTitle: false,
      isEditingDescription: false
    };
  },

  computed: {
    listTitle: {
      get() { return this.$store.getters['userInput/listTitle']; },
      set(listTitle) {
        this.$store.dispatch('userInput/setListTitle', { listTitle });
      }
    },
    listDescription: {
      get() { return this.$store.getters['userInput/listDescription']; },
      set(listDescription) {
        this.$store.dispatch('userInput/setListDescription', { listDescription });
      }
    }
  },

  methods: {

    setIsEditingListTitle(isEditing) {
      this.isEditingTitle = isEditing;

      if (isEditing) {
        this.$nextTick(() => { // See https://forum.vuejs.org/t/how-to-set-focus-to-input/10672/8
          this.$refs.linkTitle.focus();
        });
      }

      Analytics.FireFeatureUsed('edit_title', isEditing ? 'true' : 'false');
    },

    setIsEditingListDescription(isEditing) {
      this.isEditingDescription = isEditing;

      if (isEditing) {
        this.$nextTick(() => { // See https://forum.vuejs.org/t/how-to-set-focus-to-input/10672/8
          this.$refs.linkDescription.focus();
        });
      }

      Analytics.FireFeatureUsed('edit_description', isEditing ? 'true' : 'false');
    },

    saveListTitle() {
      this.isEditingTitle = false;
      this.$store.dispatch('syncToFirebase');
    },

    saveListDescription() {
      this.isEditingDescription = false;
      this.$store.dispatch('syncToFirebase');
    },

    createNewList() {
      if (window.location.pathname === '/app') {
        DataStore.clear();
      }
      window.location.href = '/app';
    }
  }
};
